import api from "./api";

export const getOrders = (page, size) => {
  return api.get(`/orders?page=${page}&size=${size}`);
};

export const createOrder = (order) => {
  return api.post("/orders", order);
};

export const updateOrder = (id, order) => {
  return api.put(`/orders/${id}`, order);
};

export const getOrderById = (id) => {
  return api.get(`/orders/${id}`, id);
}

export const updateOrderStatus = (id, status) => {
  return api.put(`/orders/status/${id}`, {"status":status})
}

export const deleteOrder = (id) => {
  return api.delete(`/orders/${id}`);
};

export const getOrdersByCustomerId = (id, page, pageSize) => {
  return api.get(`/orders/by-customer/${id}`, {params: {
    page,
    pageSize
  }})
}

export const searchOrders = (userId, filter, page, size, sort = "id,desc") => {
  const params = new URLSearchParams();

  params.append("userId", userId);
  if (filter) {
    params.append("filter", filter);
  }
  params.append("page", page);
  params.append("size", size);
  params.append("sort", sort);

  return api.get(`/orders/search?${params.toString()}`);
};

export const getOrderQrCode = (orderId) => {
  return api.get(`/orders/${orderId}/qr-code`, { responseType: 'blob' });
};
